import { NotesService } from '../../../BaseFramework/core/http/notes.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ClientService,
  ComponentOutputDO,
  UserInfoService,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';

interface noteDO {
  id: any,
  description: any,
  noteSubTypeCd: any,
  entityGuid: any,
  visibilityCd: any,
}
@Component({
  selector: 'app-notes-manager',
  templateUrl: './notes-manager.component.html',
  styleUrls: ['./notes-manager.component.scss']
})
export class NotesManagerComponent implements OnInit, OnDestroy {
  _currentComponentName = 'NotesManagerComponent'
  constructor(
    private message: NzMessageService,
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private userInfoService: UserInfoService,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private lookupDataService: LookupDataService,
    private clientService: ClientService,
    private noteService: NotesService,
    private notification: NzNotificationService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler) { }

  //Declaraions which might need developer input
  notesManagerForm: FormGroup
  NOTESMANAGERFORM = "notesManagerForm"
  selectorOfThisComponent = 'app-notes-manager'
  parentEvent$
  noteSave$

  @Output() componentOutput = new EventEmitter<any>();
  @Input() transactionState: any;
  @Input() mode: any;
  


  noteList: any;
  item
  private _IO = null;
  @Input()
  set IO(value: any) {
    this._IO = value;
    this.getDoDetails();
  };

  DO: any;
  private getDoDetails() {
    this.DO = this.getDO(this._IO);
    if (this.DO != null) {

    }
  }

  emptyNoteDO: noteDO = {
    id: null,
    description: null,
    noteSubTypeCd: null,
    entityGuid: null,
    visibilityCd: null,
  }



  get IO() {
    return this._IO;
  }

  lookupsToBind = ['docVisibilityCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
      
    } catch (error) {
      
    }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
      
    } catch (error) {
      
    }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }


  viewType: string;

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.route.data.subscribe(data => {
      this.viewType = data.breadcrumb.toUpperCase();
    });
    this.subscribeToNoteSave();
    if (this.IO != null)
      this.initializeNotesForm(this.IO)
    this.subscribeToParentEvent()
    this.getNotesByGuid();
    //this.getUserDetails();
    this.noteDO.visibilityCd = "INTERNAL"
  }

  initializeNotesForm(data?) {
    let payload = data || {}
    this.notesManagerForm = this.fb.group({

    });
  }

  subscribeToNoteSave() {
    this.noteSave$ = this.noteService.noteSaveSubject$.subscribe(resp => {
      if (resp && Array.isArray(resp.notes)) {
        let savedNote = resp.notes.find(n => true);
        if (Array.isArray(this.noteList)) {
          let foundIndex = this.noteList.findIndex(n => n.guid === savedNote.guid);
          if (foundIndex !== -1) this.noteList[foundIndex] = savedNote;
          else this.noteList.push(savedNote);
        }
        else this.noteList = resp.notes;

        this.filterNoteList();
      }
      this.getNotesByGuid();
    });
  }

  userId: any = "";
  getUserDetails() {
    this.userId = this.userInfoService.getUserId();
    return this.userId;
  }
  
getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_WITHTIME);
    }
    else {
      dateString = '-'
    }
    return dateString
  }

  getNotesByGuid() {
    if (this.DO) {
      this.noteService.getNoteByGuid(this.DO['guid']).subscribe(resp => {
        console.log("resp1  ", resp.notes)
        this.noteList = resp.notes;
        this.filterNoteList();
      },
        (error) => {
          throw " Something went wrong";
        }
      );
    }
    this.noteDO.visibilityCd = "INTERNAL"

  }

  filterNoteList() {
    let userRoleDo = this.userInfoService.getUserRoleDO();
    // if (this.appMetadataHandler.featureFlags.BSLI_Config) {
    //   if (userRoleDo && (userRoleDo.roleId == 'CALL_CENTER' || userRoleDo.roleId == 'CLAIM_BRANCHINTIMATION')) {
    //     this.noteList = this.noteList.filter(item => item.visibilityCd != 'INTERNAL');
    //   }
    // }
  }

  noteDO: noteDO = this.commonUtilty.deepCopy(this.emptyNoteDO);
  notes: any[] = [];
  noteCannedReply(message) {
    this.noteDO.description = message;
  }

  _noteSaveInProgress:any =false
  showValidationError = false;
  saveNotes() {
    this.notification.remove(); // remove error notification if already exist.
    this.showValidationError = false;
    if (!this.noteDO.description || this.noteDO.description.trim() === '' || this.noteDO.visibilityCd == null) {
      this.showValidationError = true;
      return;
    }
    this._noteSaveInProgress=true;
    this.notes = [];
    this.noteDO.entityGuid = this.DO.guid;
    this.notes.push(this.noteDO);
    let payload = { notes: this.notes }
    let serviceId = this.message.loading('Saving').messageId;
    this.noteService.saveNotes(payload).subscribe(resp => {
      this.noteDO = this.commonUtilty.deepCopy(this.emptyNoteDO);
      this.getNotesByGuid();
      this.message.remove(serviceId);
      this._noteSaveInProgress=false;
      },(error) => {
        console.log(error)
        throw " Something went wrong";
      }
    );
  }


  getDO(IO) {
    let output = null
    if (IO != null) {
      switch (this.transactionState) {
        case "notes": {
          if (IO['intimationDO'] || IO['claimDO']) {
            if (IO['intimationDO'])
              output = IO['intimationDO']

            if (IO['claimDO'])
              output = IO['claimDO']

            break;
          }
          if (IO['caseDO']) {
            output = IO['caseDO']
          }

          if (IO['proposalDO']) {
            output = IO['proposalDO']
          }
        }
        default: {
          console.log("Invalid choice");
          break;
        }
      }
    }

    return output
  }

  ngOnDestroy() {
    this.noteService.noteSaveSubject$.next(null);
    if (this.noteSave$) this.noteSave$.unsubscribe();
  }

}

